import React from "react";
import {
  View,
  Text,
  Image,
  StyleSheet,
  StatusBar,
  SafeAreaView,
} from "react-native";
import AppIntroSlider from "react-native-app-intro-slider";


const data = [
  
  {
    title: "Predict the market!",
    image:require("../assets/images/shakehands-removebg.png"),
    bg: "#59b2ab",
    text: 'Test out your investment knowledge in a virtual risk-free market',

  },
  {
    title: "With friends!",
    image:
    require("../assets/images/cover-removebg.png"),
    bg: "#febe29",
    text: 'Compete with other users through a global leaderboard',

  },
  {
    title: "Win BIG!",
    image:
    require("../assets/images/moneybagguy.png"),
    bg: "#8BA870",
    text: 'Earn points to reach the top of the global leaderboard',

  },
];

const styles = StyleSheet.create({
  slide: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 96, // Add padding to offset large buttons and pagination in bottom of page
  },
  image: {
    width: 320,
    height: 320,
    marginTop: 32,
    backgroundColor: 'transparent'

  },
  title: {
    fontSize: 22,
    color: "white",
    textAlign: "center",
  },
  text: {
    color: 'rgba(255, 255, 255, 0.8)',
    textAlign: 'center',
  },
});

export default class App extends React.Component {
  _renderItem = ({ item }) => {
    return (
      <View
        style={{
          flex: 1,
          backgroundColor: item.bg,
        }}
      >
        <SafeAreaView style={styles.slide}>
          <Text style={styles.title}>{item.title}</Text>
          <Image source={item.image} style={styles.image} />
          <Text style={styles.text}>{item.text}</Text>

        </SafeAreaView>
      </View>
    );
  };

  _keyExtractor = (item) => item.title;

  render() {
    return (
      <View style={{ flex: 1 }}>
        <StatusBar translucent backgroundColor="transparent" />
        <AppIntroSlider
          keyExtractor={this._keyExtractor}
          renderItem={this._renderItem}

          onDone={this.props.onFinished}
          onSkip={this.props.onFinished}

          showSkipButton
          showPrevButton
          data={data}
        />
      </View>
    );
  }
}
